import * as React from 'react';
export const arrowRightSvg = React.forwardRef(function arrowRightSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M9.619 1.381A.875.875 0 1 0 8.38 2.62l4.507 4.506H1a.875.875 0 1 0 0 1.75h11.888L8.38 13.381a.875.875 0 1 0 1.24 1.239l6-6a.872.872 0 0 0 0-1.238l-6-6Z',
    }),
  );
});
arrowRightSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var arrowRight = {
  category: 'icon',
  colorable: true,
  name: 'arrowRight',
  svg: arrowRightSvg,
};
